class MidiNode {
    constructor() {
        this.connections = [];
    }
    connect(unit) {
        const index = this.connections.indexOf(unit);
        if (index < 0) {
            this.connections.push(unit);
        }
        else {
            throw Error('Unit already connected');
        }
    }
    disconnect() {
        this.connections = [];
    }
    connectsTo(unit) {
        return this.connections.indexOf(unit) >= 0;
    }
    // right now, it's fine to keep variables and arguments 'untyped'.
    // we will need to fix this when all files are in es6 though...
    triggerAttack(note, time, velocity) {
        for (const connection of this.connections) {
            connection.triggerAttack.call(connection, note, time, velocity);
        }
    }
    triggerRelease(time, note) {
        for (const connection of this.connections) {
            connection.triggerRelease.call(connection, time, note);
        }
    }
}
export default MidiNode;
//# sourceMappingURL=MidiNode.js.map